import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';

class BankingPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{BankingPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <span>banking info goes here ...</span>
                    </div>
                </div>
            </div>
        );
    }
}

BankingPage.meta = {
    label: <FormattedMessage id={'bankingInfo'} defaultMessage={'Banking Info'} />,
    icon: 'payment',
    action: () => history.push('/banking'),
    locations: ['/banking']
};

export default BankingPage;



// WEBPACK FOOTER //
// ./src/pages/banking/index.jsx